import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/migration/page.tsx");
